/**
 * Phonics Letter Mm — 课程数据配置
 */

const MEDIA_BASE = '/media/phonics/mm';
const V = 'v1';

export const letterData = {
  letter: 'M',
  title: 'Phonics',
  subtitle: 'Letter M',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段 (00:11-01:48)
  songVideo: {
    src: `${MEDIA_BASE}/Mm_song.mp4?${V}`,
    poster: `${MEDIA_BASE}/image7.png?${V}`,
    startTime: 11,
    endTime: 108,
  },

  // Step 2: 4 格单词视频 (monkey / milk / mitten / map)
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image7.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image8.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
  ],

  storySections: [

    // web P3: Learn the Story (1) — 左视频 + 左下/右边台词（LinesBi 中英双语）
    {
      label: 'Learn the Story (1)',
      layout: 'story-video-left-lines-right',
      videos: [{
        src: `${MEDIA_BASE}/story_mm1.mp4?${V}`,
        poster: `${MEDIA_BASE}/image11.png?${V}`,
      }],
      lines: [
        // 左下（cnNewLine: true = 英文和中文分行显示）
        { en: 'Monkey is cold.', cn: '猴子冷', cnNewLine: true, audioEn: `${MEDIA_BASE}/story1_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3?${V}` },
        { en: 'cold',            cn: '冷',    audioEn: `${MEDIA_BASE}/w_en_cold.mp3?${V}`,    audioCn: `${MEDIA_BASE}/w_cn_cold.mp3?${V}` },
        // 右边（cnNewLine: true = 英文和中文分行显示）
        { en: 'What do I have?', cn: '我有什么呢？', cnNewLine: true, audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'have',            cn: '有',    audioEn: `${MEDIA_BASE}/w_en_have.mp3?${V}`,    audioCn: `${MEDIA_BASE}/w_cn_have.mp3?${V}` },
        { en: 'I have',          cn: '我有',  audioEn: `${MEDIA_BASE}/s_en_ihave.mp3?${V}`,  audioCn: `${MEDIA_BASE}/s_cn_ihave.mp3?${V}` },
        { en: 'Do I have ?',     cn: '我有...吗？', audioEn: `${MEDIA_BASE}/s_en_dohave.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_dohave.mp3?${V}` },
        { en: 'do ?',            cn: '表示疑问', audioEn: `${MEDIA_BASE}/s_en_do_question.mp3?${V}`, audioCn: `${MEDIA_BASE}/s_cn_do_question.mp3?${V}` },
      ],
      splitAt: 2,
    },

    // web P4: Learn the Story (2) — 无视频，纯文字跟读（5句）
    {
      label: 'Learn the Story (2)',
      headerTitle: 'Learn the Story (2)',
      layout: 'text-repeat-table',
      groups: [
        {
          rows: [
            { en: 'I have my mittens.',   cn: '我有我的手套', audioEn: `${MEDIA_BASE}/s_en_ihavemittens.mp3?${V}`,  audioCn: `${MEDIA_BASE}/s_cn_ihavemittens.mp3?${V}` },
            { en: 'Do I have mittens?',  cn: '我有手套吗？', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
            { en: 'Oh, that\'s better.', cn: 'Oh, 那样更好', audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
            { en: 'better',              cn: '更好',         audioEn: `${MEDIA_BASE}/w_en_better.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_better.mp3?${V}` },
            { en: 'that',                cn: '那样',         audioEn: `${MEDIA_BASE}/w_en_that.mp3?${V}`,   audioCn: `${MEDIA_BASE}/w_cn_that.mp3?${V}` },
          ],
        },
      ],
    },

    // web P5: Learn the Story (3) — 左上视频 + 右上单词 + 下部全宽台词
    {
      label: 'Learn the Story (3)',
      layout: 'video-left-vocab-right-lines-bottom',
      videos: [{
        src: `${MEDIA_BASE}/story_mm2.mp4?${V}`,
        poster: `${MEDIA_BASE}/image12.png?${V}`,
      }],
      // splitAt=2: lines[0..1] = 右上单词；lines[2..] = 下部台词
      lines: [
        // 右上单词
        { en: 'thirsty', cn: '口渴', audioEn: `${MEDIA_BASE}/w_en_thirsty.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_thirsty.mp3?${V}` },
        { en: 'some',    cn: '一些', audioEn: `${MEDIA_BASE}/w_en_some.mp3?${V}`,    audioCn: `${MEDIA_BASE}/w_cn_some.mp3?${V}` },
        // 下部台词
        { en: 'Monkey is thirsty.',   cn: '猴子口渴',             audioEn: `${MEDIA_BASE}/story3_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_1.mp3?${V}` },
        { en: 'What do I have?',     cn: '我有什么呢？',         audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'I have some milk.',    cn: '我有一些牛奶',         audioEn: `${MEDIA_BASE}/story3_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_2.mp3?${V}` },
        { en: 'Oh, that\'s better.', cn: '那样更好',             audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
      ],
      splitAt: 2,
    },

    // web P6: Learn the Story (4) — 左上视频 + 右上单词 + 下部全宽台词
    {
      label: 'Learn the Story (4)',
      layout: 'video-left-vocab-right-lines-bottom',
      videoWidth: 45, // 视频宽度 45%（默认50%），缩小约10%
      videos: [{
        src: `${MEDIA_BASE}/story_mm3.mp4?${V}`,
        poster: `${MEDIA_BASE}/image13.png?${V}`,
      }],
      // splitAt=2: lines[0..1] = 右上单词；lines[2..] = 下部台词
      lines: [
        // 右上单词
        { en: 'lost', cn: '迷路', audioEn: `${MEDIA_BASE}/w_en_lost.mp3?${V}`,   audioCn: `${MEDIA_BASE}/w_cn_lost.mp3?${V}` },
        { en: 'here', cn: '这里', audioEn: `${MEDIA_BASE}/w_en_here.mp3?${V}`,   audioCn: `${MEDIA_BASE}/w_cn_here.mp3?${V}` },
        // 下部台词
        { en: 'Monkey is lost.',     cn: '猴子迷路',             audioEn: `${MEDIA_BASE}/story4_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story4_cn_1.mp3?${V}` },
        { en: 'What do I have?',     cn: '我有什么呢？',         audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'I have my map.',      cn: '我有我的地图',         audioEn: `${MEDIA_BASE}/story4_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story4_cn_2.mp3?${V}` },
        { en: 'Oh, that\'s better.', cn: '那样更好',             audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
        { en: 'Monkey is here.',     cn: '猴子到这里了',         audioEn: `${MEDIA_BASE}/story4_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story4_cn_3.mp3?${V}` },
      ],
      splitAt: 2,
    },

  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图（来自 AtoZ_cover/Mm.png）
  coverPoster: `${MEDIA_BASE}/cover.png?${V}`,
};

export default letterData;
